import React, { useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { TimeSignal, TimeSignalAttribute } from 'graphql/types';
import { DurationSplitBarHoveredEntryContextProvider } from './DurationSplitBar/DurationSplitBarHoveredEntryProvider';
import { NoteDescriptionContent } from './NoteDescriptionContent';
import { DurationSplitBar } from './DurationSplitBar';
import { SplitEntryDetails } from './SplitEntryDetails';

type SplitNoteBodyProps = {
  note: TimeSignal;
  attributes?: TimeSignalAttribute[];
};

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.drawer,
    background: theme.palette.background.paper
  }
}));

export const SplitNoteBody: React.FC<SplitNoteBodyProps> = ({
  note,
  attributes
}: SplitNoteBodyProps) => {
  const classes = useStyles();
  const memorizedAttributes = useMemo(
    () => (note.sources.length > 0 ? attributes : []),
    [attributes, note.sources.length]
  );
  return (
    <>
      <DurationSplitBarHoveredEntryContextProvider>
        <div className={classes.root}>
          <NoteDescriptionContent
            note={note}
            attributes={memorizedAttributes}
          />
          <DurationSplitBar classification={note.classification} />
        </div>
        <SplitEntryDetails note={note} attributes={memorizedAttributes} />
      </DurationSplitBarHoveredEntryContextProvider>
    </>
  );
};
